import React, { forwardRef } from 'react';

import { Icon } from '../icon';
import type { IconProps } from '../icon-props';

export const EyeClose = forwardRef<SVGSVGElement, IconProps>(function EyeClose(props, ref) {
  return (
    <Icon {...props} viewBox='0 0 24 24' ref={ref}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.23,10.114A14.346,14.346,0,0,0,18.358,6.7l2.17-2.17a.75.75,0,1,0-1.061-1.06L13.935,9h0v0L3.467,19.47a.75.75,0,1,0,1.061,1.06l2.31-2.309A9.446,9.446,0,0,0,12,19.75c4.947,0,7.906-3.673,9.231-5.865A3.664,3.664,0,0,0,21.23,10.114ZM14.748,12A2.753,2.753,0,0,1,12,14.75a2.705,2.705,0,0,1-1.331-.358l3.722-3.723A2.7,2.7,0,0,1,14.748,12Zm5.2,1.112C18.786,15.031,16.21,18.25,12,18.25a7.939,7.939,0,0,1-4.059-1.133l1.635-1.635A4.185,4.185,0,0,0,12,16.25,4.255,4.255,0,0,0,16.248,12a4.178,4.178,0,0,0-.769-2.421L17.3,7.762a12.739,12.739,0,0,1,2.648,3.123A2.17,2.17,0,0,1,19.946,13.112ZM4.129,15.784a14.875,14.875,0,0,1-1.358-1.9,3.67,3.67,0,0,1,0-3.773C4.094,7.923,7.053,4.25,12,4.25a9.679,9.679,0,0,1,2.825.422.75.75,0,1,1-.431,1.436A8.213,8.213,0,0,0,12,5.75c-4.21,0-6.786,3.219-7.946,5.138a2.17,2.17,0,0,0,0,2.227,13.35,13.35,0,0,0,1.219,1.7.75.75,0,0,1-1.146.968Zm8.06-7.348a.749.749,0,0,1-.627.855,2.744,2.744,0,0,0-2.273,2.273.75.75,0,0,1-1.483-.228,4.2,4.2,0,0,1,3.527-3.527A.754.754,0,0,1,12.189,8.436Z'
        fill='currentColor'
      />
    </Icon>
  );
});
